<template>
  <section>
    <router-view></router-view>

    <section>
      <difot-report-card></difot-report-card>
    </section>
  </section>
</template>

<script>
import DifotReportCard from "../DifotReportCard";

export default {
  components: {
    DifotReportCard
  }
}

</script>